import { jsxs as r, jsx as e } from "@emotion/react/jsx-runtime";
import { SelectInputContainer as m, TextFieldContainer as p } from "../Select.styled.js";
import { useTextInputResizeObserver as s } from "./hooks/useTextInputResizeObserver.js";
import { useMultiSelectContext as c } from "./MultiSelectContext.js";
import { DropdownIndicator as d } from "./subComponents/DropdownIndicator/index.js";
import { SelectMenuList as f } from "./subComponents/MenuList/index.js";
import { SelectTextField as u } from "./subComponents/TextField/index.js";
const M = () => {
  const {
    disabled: o,
    readOnly: i,
    inputRef: t,
    handleInputClick: n,
    setOffsetTextInput: l
  } = c();
  return s(t, l), /* @__PURE__ */ r(m, { "data-readonly": i, children: [
    /* @__PURE__ */ r(p, { ref: t, onClick: n, disabled: o, children: [
      /* @__PURE__ */ e(u, {}),
      /* @__PURE__ */ e(d, {})
    ] }),
    /* @__PURE__ */ e(f, {})
  ] });
};
export {
  M as MultiSelect
};
